import AmountComponent from "./amount";
import AssignComponent from "./assign";
import BooleanComponent from "./boolean";
import CustomTitleComponent from "./customTitle";
import DateStampComponent from "./dateStamp";
import DescriptionComponent from "./description";
import { WidgetDivider } from "@coworker/reusable/components/Widgets";
import IssueComponent from "./issue";
import LocationComponent from "./location";
import RefillTypeComponent from "./refillType";
import { TaskFormMfaqArea } from "./mfaqArea";
import { TaskFormMfaqQuestion } from "./mfaqQuestion";
import MfaqGraphcardComponent from "./mfaqGraphcard";
import OptionalLocationComponent from "./optionalLocation";
import PhotosComponent from "./photos";
import { ProductAndStockPillsWidget } from "./ProductAndStockPillsWidget";
import { RelatedTasksWidget } from "./RelatedTasksWidget";
import ProductComponent from "./product";
import RadiobuttonsComponent from "./radiobuttons";
import SafetyAlarmInfoComponent from "./safety_alarm_info";
import RepeatableComponent from "./repeatable";
import ScheduleComponent from "./schedule";
import SectionComponent from "./section";
import SimpleProductComponent from "./simple_product";
import SubtitleComponent from "./subtitle";
import SupplierNumberComponent from "./supplierNumber";
import TextNoteComponent from "./textNote";
import InstructionsComponent from "./instructions";
import DescribeTheProblemComponent from "./describeTheProblem";
import AffectedQuantityComponent from "./affectedQuantity";

export const ISSUE = "issue";
export const BOOLEAN_FLAG = "boolean_flag";
export const LOCATION = "location";
export const PRODUCT = "product";
export const ASSIGN = "assign";
export const PHOTOS = "photos";
export const DATE_STAMP = "dateStamp";
export const DESCRIPTION = "description";
export const CUSTOM_TITLE = "custom_title";
export const AMOUNT = "amount";
export const RADIOBUTTONS = "radiobuttons";
export const REPEATABLE = "repeatable";
export const SCHEDULE = "schedule";
export const OPTIONAL_LOCATION = "optional_location";
export const DIVIDER = "divider";
export const SIMPLE_PRODUCT = "simple_product";
export const SUBTITLE = "subtitle";
export const SUPPLIER_NUMBER = "supplierNumber";
export const TEXT_NOTE = "text_note";
export const TUTORIALS = "tutorials";
export const SECTION = "section";
export const PRODUCT_WITH_PILLS = "product_with_pills";
export const RELATED_TASKS = "related_tasks";
const MFAQ_AREA = "mfaq_area";
export const MFAQ_QUESTION = "mfaq_question";
export const MFAQ_GRAPH_CARD = "mfaq_graph_card";
export const SAFETY_ALARM_INFO = "safety_alarm_info";
export const DESCRIBE_THE_PROBLEM = "describe_the_problem";
export const REFILL_TYPE = "refill_type";
export const AFFECTED_QUANTITY = "affected_quantity";

export type WidgetType =
  | "issue"
  | "boolean_flag"
  | "location"
  | "product"
  | "assign"
  | "photos"
  | "dateStamp"
  | "description"
  | "custom_title"
  | "amount"
  | "radiobuttons"
  | "repeatable"
  | "schedule"
  | "optional_location"
  | "divider"
  | "simple_product"
  | "subtitle"
  | "supplierNumber"
  | "text_note"
  | "tutorials"
  | "section"
  | "product_with_pills"
  | "related_tasks"
  | "mfaq_area"
  | "mfaq_question"
  | "mfaq_graph_card"
  | "safety_alarm_info"
  | "describe_the_problem"
  | "refill_type"
  | "affected_quantity";

export default {
  [AMOUNT]: AmountComponent,
  [ASSIGN]: AssignComponent,
  [BOOLEAN_FLAG]: BooleanComponent,
  [CUSTOM_TITLE]: CustomTitleComponent,
  [DATE_STAMP]: DateStampComponent,
  [DESCRIPTION]: DescriptionComponent,
  [DIVIDER]: WidgetDivider,
  [ISSUE]: IssueComponent,
  [LOCATION]: LocationComponent,
  [REFILL_TYPE]: RefillTypeComponent,
  [MFAQ_AREA]: TaskFormMfaqArea,
  [MFAQ_QUESTION]: TaskFormMfaqQuestion,
  [MFAQ_GRAPH_CARD]: MfaqGraphcardComponent,
  [OPTIONAL_LOCATION]: OptionalLocationComponent,
  [PHOTOS]: PhotosComponent,
  [PRODUCT_WITH_PILLS]: ProductAndStockPillsWidget,
  [RELATED_TASKS]: RelatedTasksWidget,
  [PRODUCT]: ProductComponent,
  [RADIOBUTTONS]: RadiobuttonsComponent,
  [SAFETY_ALARM_INFO]: SafetyAlarmInfoComponent,
  [REPEATABLE]: RepeatableComponent,
  [SCHEDULE]: ScheduleComponent,
  [SECTION]: SectionComponent,
  [SIMPLE_PRODUCT]: SimpleProductComponent,
  [SUBTITLE]: SubtitleComponent,
  [SUPPLIER_NUMBER]: SupplierNumberComponent,
  [TEXT_NOTE]: TextNoteComponent,
  [TUTORIALS]: InstructionsComponent,
  [DESCRIBE_THE_PROBLEM]: DescribeTheProblemComponent,
  [AFFECTED_QUANTITY]: AffectedQuantityComponent,
};
